module.exports = __webpack_public_path__ + "img/Karine.69632d3b.jpg";